module.exports = __webpack_public_path__ + "static/img/3-6.10.5.21d69ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/5/3-6.10.5.png
// module id = NpJh
// module chunks = 0